import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Select,
    Box,
    Flex,Image,
    Text,Button,Card,CardBody,SimpleGrid,
    Textarea,Checkbox
  } from "@chakra-ui/react";
  import { toast } from "react-hot-toast";
  import { useSelector } from "react-redux";
  import menu1 from '../../assets/img/biriyani1.jpg'
  import  menu2 from '../../assets/img/chickencurry.jpg'
  import menu3 from '../../assets/img/polao.jpg'
  import axios from 'axios'
  import "react-calendar/dist/Calendar.css";
  import Calendar from "react-calendar";
  import React, { useState,useEffect } from "react";
  import Cookies from 'js-cookie'
import { use } from "react";
  const array = [
    { src: menu1, label: 'Biriyani' },
    { src: menu2, label: 'Chicken Curry' },
    { src: menu3, label: 'Polao' },
   
  ];
  
 
  
  const PrintData = () => {
    // const [data1, setData1] = useState(new Date());
    // console.log(data1.toDateString());
    // const [data2, setData2] = useState(new Date());
    // console.log(data2.toDateString());
    // const [total, setTotal] = useState(0);
    // const [advance, setAdvance] = useState(0);
    //let dueAmount = 0;
    const [dueAmount, setDueAmount] = useState(0); 
    const [selectedFile, setSelectedFile] = useState(null);
  const[newimageURL,setImageURL]=useState(null);
  const [uploading, setUploading] = useState(false);
  const [printData,setPrintData]=useState([])
  const [images,setImages]=useState([])
  const [id,setId]=useState("")
 const customerId=localStorage.getItem('customerId')
    // const handlePost = async () => {
    //   try {
    //     setUploading(true);
    //     const formData = new FormData();
    //     formData.append('customerId', customerId);
    //     formData.append('image', selectedFile);  // Ensure the field name is 'image' here
    
    //     const response = await axios.post("https://api.hotel.tdrsoftware.in/images", formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    //     });
    //     const data = response.data;
    //     setImageURL(Object.values(data).join());
    //  toast.success("Image uploaded successfully");
    //     console.log(data,'data')
    //   } catch (err) {
    //     toast.error(err);
    //   } finally {
    //     setUploading(false);
    //   }
      
    // };

    const fetchData3 = async () => {
      try {
        const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
        const rooms = response.data;
    
        // Map over rooms and fetch images dynamically
        const updatedRooms = await Promise.all(
          rooms.map(async (room) => {
            if (room.image) {
              const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
                responseType: 'blob', // Assuming image is returned as a blob
              });
    
              // Create a URL for the image blob
              room.imageUrl = URL.createObjectURL(imageResponse.data);
            } else {
              room.imageUrl = null; // Handle cases where image is missing
            }
            return room;
          })
        );
    
        console.log(updatedRooms, 'updatedRooms');
        setPrintData(updatedRooms);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const handlePost = async () => {
      try {
        setUploading(true);
    
        if (!selectedFile) {
          toast.error("Please select a file to upload.");
          return;
        }
    
        const formData = new FormData();
        formData.append('image', selectedFile); // Ensure 'image' matches the backend field name
    
        const response = await axios.post(
          "https://api.rcb.tdrsoftware.in/upload", // Corrected URL
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
    
        const data = response.data;
    
        // Update state with uploaded image URL
        setImageURL(data.filename); // Adjust based on backend response
        toast.success("Image uploaded successfully");
        console.log(data, 'Upload response');
      } catch (err) {
        console.error("Upload failed:", err);
        toast.error("Image upload failed. Please try again.");
      } finally {
        setUploading(false);
      }
    };
   // console.log(imageURL,'imageURL')
    
    const [formData, setFormData] = useState({
      name: "",
      adress: "",
      phoneNo:"",
      email:'',
      acNo:'',
       ifsc:'',
       branch:'',
       website:"",
       gstNo:"",
       roomType:"",
       gst:false,
     
      
      image: "",
      
      
      
    });
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
     
      
    }
      

    const validateForm = () => {
      const requiredFields = [
        "name",
        "adress",
        "phoneNo",
        "email",
        "roomType"
        
        
      ];
  
      for (const field of requiredFields) {
        if (!formData[field]) {
          return false;
        }
      }
      return true;
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
        const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
        }));
      };
    const token=Cookies.get('token')
    useEffect(() => {
      fetchData3();
    }, [customerId]);
    console.log(printData,'printData')
    useEffect(() => {
      if(printData.length>0){
        setId(printData[0]._id)
        setFormData({
        name: printData[0].name,
      adress: printData[0].adress,
      phoneNo: printData[0].phoneNo,
      email: printData[0].email,
      acNo: printData[0].acNo,
       ifsc: printData[0].ifsc,
       branch: printData[0].branch,
       website: printData[0].website,
       gstNo: printData[0].gstNo,
       roomType: printData[0].roomType,
       gst: printData[0].gst,
     
      
      image: printData[0].image?printData[0].image:null,
        })

        
      }
    }, [printData]);
  
    const handleSubmit = async(e) => {
      if (!validateForm()) {
        toast.error("Please fill in all required fields.");
        return;
      }
      e.preventDefault();
      // Here you can send formData to your backend server or process it further
      console.log("Form submitted with data:", formData);
     
      // Reset form after submission
      setFormData({
        name: formData.name,
      adress:formData.adress,
      phoneNo:formData.phoneNo,
      email:formData.email,
      acNo:formData.acNo,
      ifsc:formData.ifsc,
      branch:formData.branch,
      website:formData.website,
      gstNo:formData.gstNo,
      roomType:formData.roomType,
      gst:formData.gst,
      image:newimageURL
      
       
      });
    
      
    };
    const save=async(e)=>{
      if (!validateForm()) {
        toast.error("Please fill in all required fields.");
        return;
      }
      if(printData.length>0){
        const updatedDate={
          ...formData,
          
          image:formData.image === "" || null ?newimageURL:formData.image
        }
        try {
          const response=await axios.put(`https://api.hotel.tdrsoftware.in/api/updatePrintData/${customerId}/${id}?customerId=${customerId}`,updatedDate,
            {
              headers: {
                Authorization:`Bearer ${token}`
              },
            }
          );
          toast.success(response.data.message)
          setId('')
          fetchData3()

        } catch (error) {
          toast.error(error.response.data.message)
        }
      }else{
        try{
          const response=await axios.post("https://api.hotel.tdrsoftware.in/api/printRegister",{
            customerId:customerId,data:formData
          });
          console.log('Data Submitted: ',response.data);
          toast.success(response.data.message)
          setFormData({
            name: "",
            adress: "",
        phoneNo:"",
        email:'',
        acNo:'',
         ifsc:'',
         branch:'',
         website:"",
         gstNo:"",
         roomType:"",
         gst:false,
  
       
        
        image: "",
          
          
          
           
          });
        }catch(error){
          toast.error(error)
        }
      }
      
    }
    
    return (
      <Box   bg='#EAE5DF '
      columns={{ sm: 2, md: 4 }}
      spacing='8'
      p='10'
      textAlign='center'
      
      color='black' width='full' height='fit-content' overflowX='auto'  >
        
        <FormControl isRequired onSubmit={handleSubmit}>
          <Box display="grid"  gridGap={1} >
            <Flex
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
             
            >
              <Box width="40%"  display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              
              p={4}>
                <FormLabel  >Hotel Name</FormLabel>
                <Input w='70%' bg='#FAFAFA ' placeholder="Enter Hotel Name "  name='name' value={formData.name} onChange={handleInputChange} />
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Address</FormLabel>
                <Textarea w='70%' bg='#FAFAFA ' type="text" placeholder="Enter Address" name='adress' value={formData.adress} onChange={handleInputChange} />
              </Box>
            </Flex>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Phone</FormLabel>
                <Input w='66%' bg='#FAFAFA ' placeholder="Enter Phone" name='phoneNo' value={formData.phoneNo} onChange={handleInputChange}/>
                 
                 
                
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Email</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' placeholder="Enter Email" name='email' value={formData.email} onChange={handleInputChange} />
                  
                  
              </Box>
              
             
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Website</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' placeholder="Hotel Website" name='website' value={formData.website} onChange={handleInputChange} />
                  
                  
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>GST No</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' placeholder="GST No" name='gstNo' value={formData.gstNo} onChange={handleInputChange}/>
              </Box>
              
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
               
              <Box width="60%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Room Types</FormLabel>
                <Textarea w='80%'  bg='#FAFAFA ' placeholder="Room Types" name='roomType' value={formData.roomType} onChange={handleInputChange}/>
              </Box>
                <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                
                <Checkbox w='80%' bg='#FAFAFA ' placeholder="Gst" name='gst' isChecked={formData.gst} onChange={handleCheckboxChange} >Gst</Checkbox>
              </Box>
              
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>A/C No</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' placeholder="Account Number" name='acNo' value={formData.acNo} onChange={handleInputChange} />
                  
                  
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>IFSC</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' placeholder="IFSC Code" name='ifsc' value={formData.ifsc} onChange={handleInputChange}/>
              </Box>
              
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Branch</FormLabel>
                <Input w='80%' bg='#FAFAFA ' placeholder="Branch Name" name='branch' value={formData.branch} onChange={handleInputChange} />
              </Box>
              
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Image</FormLabel>
                <Input w='70%' type="file" bg='#FAFAFA ' onChange={handleFileChange}  />
                <Button variant='solid' onClick={handlePost} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload"}
      </Button>
                
              </Box>
             
            </Box>
            
            
           
             
             
           
            
           
            
            
          <hr/>
          

          </Box>
         
          {/* <Button type="submit" variant='solid' mr={4} color='#0F172B' bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={handleSubmit}>Submit</Button> */}
          <Button type="submit" variant='solid' color='#0F172B' bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={save}>{printData[0]?"Update":"Save"}</Button>
        </FormControl>
        
      </Box>
    );
  };
  
  export default PrintData;
  